/**
 * Amplify KeyValueStorage with a namespace prefix so dev/prod Cognito
 * tokens never collide on the same origin (e.g. localhost).
 */
export class PrefixedKeyValueStorage {
  constructor(namespace) {
    this.namespace = String(namespace || "default");
  }

  _key(key) {
    return `${this.namespace}::${key}`;
  }

  async setItem(key, value) {
    localStorage.setItem(this._key(key), value);
  }

  async getItem(key) {
    return localStorage.getItem(this._key(key));
  }

  async removeItem(key) {
    localStorage.removeItem(this._key(key));
  }

  async clear() {
    const prefix = `${this.namespace}::`;
    const keysToRemove = [];

    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  }
}
